import { Injectable } from '@angular/core';
import { mapFetchResultData } from '@x/common/graph';
import { Observable } from 'rxjs';
import {
  ShopProductSearchAutoCompleteGQL,
  ShopProductSearchGQL,
} from './gql/shop-product-search.gql.generated';
import {
  IShopProductSearchAutoCompleteQuery,
  IShopProductSearchQuery,
  IShopProductSearchResult,
  IShopSearchQuerySuggestionItem,
} from './types/shop-product-search';

@Injectable()
export class ShopProductSearchService {
  constructor(
    private readonly productSearchGql: ShopProductSearchGQL,
    private readonly productSearchAutoCompleteGQL: ShopProductSearchAutoCompleteGQL,
  ) {}

  fetchProductSearch(query: IShopProductSearchQuery): Observable<IShopProductSearchResult> {
    return this.productSearchGql.fetch(query).pipe(mapFetchResultData((r) => r.shopProductsSearch));
  }

  fetchProductSearchAutoComplete(
    query: IShopProductSearchAutoCompleteQuery,
  ): Observable<IShopSearchQuerySuggestionItem[]> {
    return this.productSearchAutoCompleteGQL
      .fetch(query)
      .pipe(mapFetchResultData((r) => r.results.items));
  }
}
